export default __webpack_public_path__ + "ab17723b4c217ea559dfb58165482e33.png";